import React from "react";
import { RiGolfBallLine } from "react-icons/ri";
import bannerVideo from "../assets/videos/banner_video.mp4";
import { Link } from "react-router-dom";
const HeroSection = () => {
  return (
    <section
      className="relative md:h-[calc(100vh-130px)] bg-black text-white pt-28 pb-20 overflow-hidden"
      // style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* <div className="absolute inset-0 bg-black/70 z-0"></div> */}
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={bannerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Dark overlay */}
      {/* <div className="absolute inset-0 bg-black/70 z-0"></div> */}

      <div className="relative z-10 container mx-auto px-6 md:px-12 flex flex-col items-center md:items-start text-center md:text-left space-y-6">
        <p className="uppercase tracking-widest text-lime-400 font-semibold flex items-center space-x-2">
          <span>
            <RiGolfBallLine className="bg-yellow-100 rounded-[50px]" />
          </span>
          <span>Welcome to Rangpur Golf & Country Club.</span>
        </p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
          Where excellence meets <br /> passion on every green
        </h1>
        <Link
          to="/membership"
          className="relative group overflow-hidden bg-lime-400 text-black font-bold py-3 px-6 rounded-full flex items-center space-x-2 transition-colors duration-500"
        >
          {/* Curtain overlay */}
          <span className="absolute inset-0 bg-black origin-bottom-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700 ease-in-out z-0"></span>

          {/* Text & Icon (above curtain) */}
          <span className="relative z-10 flex items-center space-x-2 group-hover:text-white transition-colors duration-500">
            <span className="uppercase">Get Membership</span>
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </span>
        </Link>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
          We conduct frequent golf tournaments
        </h2>
      </div>

      {/* Features */}
      {/* <div className="relative z-10 container mx-auto px-6 md:px-12 mt-16 grid grid-cols-1 md:grid-cols-4 gap-10 text-center md:text-left">
        <div className="relative pt-2 group">
          <span className="block absolute top-0 left-0 h-0.5 bg-lime-400 w-0 group-hover:w-full transition-all duration-500"></span>
          <div className="flex justify-center md:justify-start mb-2 mt-[5px]">
            <FaGem className="text-lime-400 text-2xl" />
          </div>
          <h3 className="font-bold text-white">Premium Materials</h3>
          <p className="text-white/80 text-sm">
            Crafted with high-quality durable materials for superior
            performance.
          </p>
        </div>
        <div className="relative pt-2 group">
          <span className="block absolute top-0 left-0 h-0.5 bg-lime-400 w-0 group-hover:w-full transition-all duration-500"></span>
          <div className="flex justify-center md:justify-start mb-2">
            <FaGolfBall className="text-lime-400 text-2xl" />
          </div>
          <h3 className="font-bold text-white">Advanced Forgiveness</h3>
          <p className="text-white/80 text-sm">
            Engineered for maximum forgiveness on off-center hits.
          </p>
        </div>
        <div className="relative pt-2 group">
          <span className="block absolute top-0 left-0 h-0.5 bg-lime-400 w-0 group-hover:w-full transition-all duration-500"></span>
          <div className="flex justify-center md:justify-start mb-2">
            <FaTools className="text-lime-400 text-2xl" />
          </div>
          <h3 className="font-bold text-white">Customizable Options</h3>
          <p className="text-white/80 text-sm">
            Tailor your club to fit your swing style and preferences.
          </p>
        </div>
        <div className="relative pt-2 group">
          <span className="block absolute top-0 left-0 h-0.5 bg-lime-400 w-0 group-hover:w-full transition-all duration-500"></span>
          <div className="flex justify-center md:justify-start mb-2">
            <FaLeaf className="text-lime-400 text-2xl" />
          </div>
          <h3 className="font-bold text-white">Sleek, Modern Design</h3>
          <p className="text-white/80 text-sm">
            Combines aesthetics with your cutting-edge technology.
          </p>
        </div>
      </div> */}
    </section>
  );
};

export default HeroSection;
